export default __webpack_public_path__ + "static/media/United_Kingdom.5aa2f382.svg";